import { gameTypes, isContestGamesWithSecondaryUgc } from 'config/promoGameTypes';
import checkInReducer, { init as initCheckIn } from 'client/game_checkIn/redux/reducer';
import contestReducer, { init as initContest } from 'client/game_photoContest/redux/reducer';
import commentReducer from 'client/game_comment/redux/reducer';
import orderRewardReducer from 'client/game_orderReward/redux/reducer';
import relatedTwinsPromo from 'client/redux/modules/relatedTwinsPromo';
import { defaultState as checkInDefaultState } from 'client/game_checkIn/redux/modules/gameState';
import { defaultState as contestDefaultState } from 'client/game_photoContest/redux/modules/gameState';
import { defaultState as commentDefaultState } from 'client/game_comment/redux/modules/gameState';
import { defaultState as orderRewardDefaultState } from 'client/game_orderReward/redux/modules/gameState';

export function getGameReducer(gameType, hasRelatedTwinsPromo, isMgmSelf) {
    let reducer = {};
    if (hasRelatedTwinsPromo) {
        reducer = { ...reducer, relatedTwinsPromo };
    }
    const game = getCustomGameReducerByGameType(gameType);
    const mgm = getCustomGameReducerByMgmSelf(isMgmSelf);
    const gameReducer = game.reducer;
    const mgmReducer = mgm.reducer;
    const gameDefaultState = game.defaultState;
    const mgmDefaultState = mgm.defaultState;

    if (gameReducer && mgmReducer) {
        reducer = {
            ...reducer,
            ...{
                gameState: combineReducers([gameReducer, mgmReducer], {
                    ...gameDefaultState,
                    ...mgmDefaultState
                })
            }
        };
    } else if (gameReducer) {
        reducer = { ...reducer, ...gameReducer };
    } else if (mgmReducer) {
        reducer = { ...reducer, ...mgmReducer };
    }

    return reducer;
}

function combineReducers(props = [], defaultState = {}) {
    return function (state = { ...defaultState }, action) {
        let nextState = { ...state };

        props.forEach(reducer => {
            nextState = {
                ...nextState,
                ...reducer.gameState(nextState, action)
            };
        });

        return nextState;
    };
}

export async function initGameReducer(gameType, dispatch) {
    const init = getCustomGameReducerByGameType(gameType).init;
    if (typeof init === 'function') {
        return init(dispatch);
    }
}

export async function initMgmSelfReducer(dispatch, isMgmSelf) {
    const initMgmSelf = getCustomGameReducerByMgmSelf(isMgmSelf).init;
    if (typeof initMgmSelf === 'function') {
        return initMgmSelf(dispatch);
    }
}

function getCustomGameReducerByGameType(gameType) {
    switch (true) {
        case gameType === gameTypes.COMMENT:
            return { reducer: commentReducer, defaultState: commentDefaultState };
        case gameType === gameTypes.ORDER_REWARD:
            return { reducer: orderRewardReducer, defaultState: orderRewardDefaultState };
        case gameType === gameTypes.CHECK_IN:
        case gameType === gameTypes.CHALLENGE_PHOTO_FRAME_COMPOSITE:
        case gameType === gameTypes.MGM_SHARE:
        case gameType === gameTypes.MULTI_CHALLENGE:
            return {
                reducer: checkInReducer,
                init: initCheckIn,
                defaultState: checkInDefaultState
            };
        case isContestGamesWithSecondaryUgc(gameType):
            return {
                reducer: contestReducer,
                init: initContest,
                defaultState: contestDefaultState
            };
        default:
            return {};
    }
}

function getCustomGameReducerByMgmSelf(isMgmSelf) {
    if (isMgmSelf) {
        return { reducer: checkInReducer, init: initCheckIn, defaultState: checkInDefaultState };
    }
    return {};
}
